var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-insurance-poster"},[_c('img',{staticClass:"insurance-poster",attrs:{"src":_vm.poster}}),_c('div',{staticClass:"save-button-box"},[_c('div',{staticClass:"save-button",on:{"click":_vm.previewImg}},[_vm._v("保存至相册或分享好友")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }